import gql from 'graphql-tag';
import { AddressFragment } from '../fragments';

export const onboardingBuildings = gql`
  ${AddressFragment}

  query OnboardingBuildings(
    $onboardingChannelFilter: OnboardingCompaniesFilterInput
    $pageInfo: ConnectionPageInfoInput
  ) {
    onboardingBuildings(
      onboardingChannelFilter: $onboardingChannelFilter
      pageInfo: $pageInfo
    ) {
      edges {
        cursor
        node {
          id
          matchesEmailDomain
          name
          thumbnailUrl
          address {
            ...AddressFragment
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;
